import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const LocationFound = _ref => {
  let {
    color = '#788590',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.797v0c2.875 0 5.203 2.329 5.203 5.203s-2.328 5.203-5.203 5.203c-2.875 0-5.203-2.328-5.203-5.203s2.328-5.203 5.203-5.203zM27.629 14.699c-0.598-5.424-4.904-9.73-10.328-10.328v-2.68h-2.602v2.68c-5.424 0.598-9.73 4.904-10.328 10.328h-2.68v2.602h2.68c0.598 5.424 4.904 9.73 10.328 10.328v2.68h2.602v-2.68c5.424-0.598 9.73-4.904 10.328-10.328h2.68v-2.602h-2.68zM16 25.106c-5.034 0-9.106-4.072-9.106-9.106s4.072-9.106 9.106-9.106c5.034 0 9.106 4.072 9.106 9.106s-4.072 9.106-9.106 9.106v0z",
    fill: color
  }));
};
export default LocationFound;